/* mp-pdp-tabs.js — 09.09.2026 (Felix)
 *
 * Zwei Dinge auf der Produktseite:
 *  1. Der Beschreibungstext war zugeklappt. Er ist der Inhalt, nach dem der
 *     Kunde sucht, und soll offen stehen.
 *  2. Mobil stand "Beschreibung" zweimal untereinander: einmal als Reiter,
 *     einmal als Akkordeon-Zeile. Die zweite Zeile entfaellt, solange nur ein
 *     Abschnitt existiert.
 */
(function () {
  function ersterInhalt() {
    var w = document.querySelector('.t4s-product-tabs-wrapper');
    if (!w) return;

    // 1) offen, wenn nichts offen ist
    var offen = w.querySelector('.t4s-tab-content.t4s-active');
    if (!offen) {
      // 10.09.2026: nicht mehr klicken (der Anker-Klick scrollte die Seite beim
      // Laden ~1200 px nach unten), sondern die Aktiv-Klassen direkt setzen.
      var reiter = w.querySelector('[data-t4s-tab-item]');
      var erster = w.querySelector('.t4s-tab-content');
      if (reiter) {
        reiter.classList.add('t4s-active');
        var li = reiter.closest('li'); if (li) li.classList.add('t4s-active');
      }
      if (erster) {
        erster.classList.add('t4s-active');
        if (erster.parentElement) erster.parentElement.classList.add('t4s-active');
      }
    }

    // 2) doppelte Zeile bei nur einem Abschnitt
    var reiterAnzahl = w.querySelectorAll('.t4s-tabs-pr-ul li').length;
    if (reiterAnzahl <= 1) {
      w.querySelectorAll('[data-t4s-accordion-btn], .t4s-accordion__title').forEach(function (e) {
        e.setAttribute('hidden', '');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ersterInhalt);
  } else {
    ersterInhalt();
  }
  // Das Theme baut den Bereich teils nach; ein zweiter Anlauf nach dem Laden.
  window.addEventListener('load', function () { setTimeout(ersterInhalt, 400); });
})();
